import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			staleTime: 6000,
		},
		mutations: {
			retry: false,
		},
	},
});

export function getQueryClientContext() {
	return {
		queryClient,
	};
}

export function TanStackQueryProvider({ children }: { children: React.ReactNode }) {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
